module.exports = __webpack_public_path__ + "assets/img/EXTERNAL_PLUGIN.7378a8ac.svg";